/**
 * PORTED — RO-3-00c / #44470.
 * Origin: `excellent/app/_modes/sales-title-toolbar.tsx`.
 *
 * Changes:
 *   `@excellent/core/server` lists → `useApi(modes.salesChrome, {})` (READ)
 *   `SalesSectionControls` is still Next-bound (uses next/router + unported
 *   CRM create modals from RO-3-00d). Until that lands, this toolbar surfaces
 *   the pipeline count as a compact read-only chip so the Mode Shell chrome
 *   never reaches the vault. The full controls re-attach when RO-3-00d ports
 *   `_crm/section-controls` + the create modals.
 */

import { Badge } from "@excellent/ui";
import { useApi } from "@excellent/ui/api";
import { modes } from "@excellent/ui/api/contracts/modes";
import { domainSectionPath } from "@/modes/domains";

export function SalesTitleToolbar({
  projectSlug,
}: {
  searchParams: Record<string, string | string[] | undefined> | undefined;
  workspaceId: number;
  projectSlug?: string;
}) {
  const { data } = useApi(modes.salesChrome, {});
  // boardBase preserved so a future controls mount keeps the same URL contract.
  void domainSectionPath(
    { mode: "customers", label: "Sales" },
    projectSlug ?? null,
  );
  const n = data?.pipelines?.length ?? 0;
  return (
    <Badge variant="outline" className="font-normal">
      {n === 1 ? "1 pipeline" : `${n} pipelines`}
    </Badge>
  );
}
